import React, { useState, useEffect } from "react";
import AccountStats from "./AccoutStats/AccountStats";
import "./index.css";
import StatusCheck from "./StatusCheck/StatusCheck";
import LiveTrades from "./LiveTrades/LiveTrades";
import { useSelector } from "react-redux";
import PotentialTradingAccount from "./PotentialTradingAccount";
import CopyTradingStats from "./DashboardStats";
import useApi from "../../helpers/apiHelper/requestHelper";
import MemberTradingGraph from "../sharedPages/Member/MemberTradingGrapgh";
import DashboardMarketSelectBar from "../sharedPages/CommonComponents/DashboardMarketSelect/DashboardMarketSelectBar";
import { useDashboardMarket } from "../sharedPages/CommonComponents/DashboardMarketSelect/DashboardMarketContext";

const NewDashboard = () => {
  const { user } = useSelector((state) => state.user);
  const { permissionType } = useDashboardMarket();
  const api = useApi();
  const [stats, setStats] = useState({});
  const isLeader = user?.role === "leader";
  const isMember = user?.role !== "leader";

  const getUserStats = async () => {
    const response = await api("post", "multiCommunity/getSpecificUserStats", {
      userIds: [user?._id],
    });
    if (response?.status) setStats(response?.data);
  };

  useEffect(() => {
    if (user) getUserStats();
  }, [user]);

  return (
    <div className="DashboardPage testme">
      {permissionType === "both" && <DashboardMarketSelectBar />}
      <div className={`firstRow${isMember ? " firstRow--member" : ""}`}>
        <AccountStats user={user} />
        {isMember && (
          <>
            <CopyTradingStats stats={stats} />
            <PotentialTradingAccount stats={stats} />
          </>
        )}
        <div className="d-lg-none d-md-none firstRow__mobileLiveTrades">
          <LiveTrades user={user} />
        </div>
      </div>

      {isMember && (
        <div className="d-lg-block d-md-block d-none">
          <LiveTrades user={user} />
        </div>
      )}

      <div style={{ marginBottom: "30.6px" }}>
        <MemberTradingGraph user={user} stats={stats} />
      </div>

      {isLeader && (
        <div className="d-lg-block d-md-block d-none">
          <LiveTrades user={user} />
        </div>
      )}
      <StatusCheck user={user} />
    </div>
  );
};

export default NewDashboard;
